import { User, UserWithSubscriptions } from '@api/apiCompat';
import { TRIAL_DAYS } from '@constants/auth';
import { ProfileData } from '@pages/Settings/types';
import { differenceInDays } from 'date-fns';

export const isFieldsDiffer = (initialField: string, updatedField: string) => initialField !== updatedField;
export const getUpdateMePayload = (formData: ProfileData, userData: User) => {
  const user = userData as UserWithSubscriptions | undefined;
  return {
    ...(isFieldsDiffer(formData.firstname as string, (user?.firstname || user?.first_name) as string) && {
      firstname: formData.firstname,
    }),
    ...(isFieldsDiffer(formData.lastname as string, (user?.lastname || user?.last_name) as string) && {
      lastname: formData.lastname,
    }),
    ...(isFieldsDiffer(formData.phone as string, (user?.phone || '') as string) && { phone: formData.phone }),
    ...(isFieldsDiffer(formData.email as string, (user?.email || '') as string) && { email: formData.email }),
  };
};

export const convertFromCents = (price: number) => (price / 100).toFixed(2);

export const isTrialExpired = (createdDate: string): boolean => {
  const createdDateObject = new Date(createdDate);
  const currentDate = new Date();
  return differenceInDays(currentDate, createdDateObject) > TRIAL_DAYS;
};
